import { Component, OnInit } from '@angular/core';
import { RoleMaster } from '../../user-center/user-role/user-role.component';
import { SchoolService } from '../school.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Role, RolePayload } from '../../../models/role.model';
import { ToastrService } from 'ngx-toastr';
import { DtoSchool, DtoSchoolUser } from '../../../models/school.model';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';
import { DocumentType, MatDialogCloseEvent } from '../../../const';
import { AddSchoolUserComponent } from '../add-school-user/add-school-user.component';
import { ActionType } from '../school-details/school-details.component';
import { MatDialog } from '@angular/material/dialog';
import { EditSchoolComponent } from '../../user-center/edit-school/edit-school.component';
import { CommentDialogComponent } from '../../../shared/components/comment-dialog/comment-dialog.component';
import { ConfirmDialogComponent } from '../../mat-account/confirm-dialog/confirm-dialog.component';
import { MatAccountService } from '../../mat-account/mat-account.service';
import { UserRoles } from '../../../models/mat-account.model';
import { Users } from '../../../models/user-center.model';

@Component({
  selector: 'app-school-list',
  templateUrl: './school-list.component.html'
})
export class SchoolListComponent implements OnInit {
  userRole: string[] = [];
  rolesMaster = RoleMaster;
  roleName: string[] = [];
  userEmail: string = "";
  packageId: number = 0;
  clientAccountId: number = 0;
  createSchool: boolean = false;
  schoolData: DtoSchool[] = [];
  schoolUsers: DtoSchoolUser[] = [];
  showSchoolUser: boolean = false;
  roles: Role[] = [];
  schoolName: string = "";
  schoolId: number = 0;
  roleMaster = RoleMaster;
  accountAdminList: Users[] = [];
  schoolAdminExists: boolean = false;

  constructor(public dialog: MatDialog,
              private toasterService: ToastrService,
              private schoolService: SchoolService,
              private matAccountService: MatAccountService
  ){}

  ngOnInit(): void {
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(RoleMaster, element)!);
    });
    this.getAssignedPackageId(this.userEmail);
    this.getAccountAdminDetails();
  }

  getAccountAdminDetails() {
    let payload: UserRoles = {} as UserRoles;
    payload.userRole = this.userRole;
    this.matAccountService.getAccountAdminDetails(this.userRole).subscribe((response: Users[] | any) => {
      this.accountAdminList = response;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }
  
  getRoles(clientAccountId: number){
    let payload = {
      isIndividualEntity : clientAccountId == 0,
      clientAccountId : clientAccountId > 0 ? [clientAccountId] : this.schoolData.map(x=>x.schoolId)
    } as RolePayload;
    this.schoolService.getRoles(payload).subscribe((response: Role[] | any)=>{
    //this.schoolService.getRoles(clientAccountId).subscribe((response: Role[] | any)=>{
      this.roles = response;
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }
  
  getAssignedPackageId(emailId: string) {
    this.schoolService.getAssignedPackageId(emailId).subscribe((response: any) => {
      this.packageId = response.packageId;
      this.clientAccountId = response.clientAccountId;
      this.getSchoolDetails(this.clientAccountId);
      this.getRoles(this.clientAccountId);
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  getSchoolDetails(clientAccountId: number, payload: any = {}){
    this.schoolService.getSchools(clientAccountId, payload).subscribe((data: DtoSchool[] | any)=>{
      this.schoolData = data;
    }, (error: HttpErrorResponse)=>{
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  openCommentModal(comment: string) {
    this.dialog.open(CommentDialogComponent, {
      width: '500px',
      data: comment
    });
  }
  
  editSchool(school: DtoSchool){
    this.dialog.open(EditSchoolComponent,{
      width: '1000px',
      data: { school: school, isEdit: true, accountAdminList: this.accountAdminList }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.getSchoolDetails(this.clientAccountId);
      }
    })
  }

  deleteSchool(school: DtoSchool){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the school?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.schoolService.deleteSchool(school.schoolId!).subscribe((response: any)=>{
          if (response) {
            this.toasterService.success('School deleted successfully', 'Success');
            this.getSchoolDetails(this.clientAccountId);
          }
        }, (errorResponse: HttpErrorResponse) => {
          if(errorResponse.error){
            this.toasterService.error(errorResponse.error, "Error");
          }
        })
      }
    });
  }

  goToSchoolUsers(school: DtoSchool){
    this.schoolUsers = this.schoolData.filter(schoolUser => schoolUser.schoolId == school.schoolId)[0].schoolUsers;

    this.schoolAdminExists = this.schoolUsers?.some(user =>
      user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
    );

    this.showSchoolUser = true;
    this.schoolName = school.schoolName!;
    this.schoolId = school.schoolId!;
  }
  
  actionTriggered(value: any) {
    let action = value.action;
    let index = value.index;
    switch(action){
      case ActionType.EditSchoolUser:
        this.openCreateSchoolUserDialog(this.schoolUsers[index]);
        return;
      case ActionType.DeleteSchoolUser:
        this.openDeleteSchoolUser(index);
        return;
      default:
        return ""
    }
  }

  hideHeader(){
    this.createSchool = false;
    this.getSchoolDetails(this.clientAccountId);
  }

  create(){
    if(this.schoolUsers.length){
      //Create School Users
      this.openCreateSchoolUserDialog();
    }
    else{
      //Create School
      this.createSchool = true;
    }
  }

  async openCreateSchoolUserDialog(userDetail: DtoSchoolUser = {} as DtoSchoolUser): Promise<any>{
    //Opened upon Create School User by MAT Admin
    try{
      let numberOfUsers = await this.matAccountService.allowCreateSchoolUser(this.schoolId);
      if (numberOfUsers) {
        userDetail.contactNumber = userDetail.phoneNumber;
        if(userDetail.role?.length && userDetail.role?.length == 1 && userDetail.role[0].roleName == "SchoolAdmin"){
          userDetail.isAdmin = true;
        }
       
        this.schoolService.getSchools(this.clientAccountId).subscribe((data: DtoSchool[] | any)=>{
          this.schoolData = data;
          this.schoolUsers = this.schoolData.find(data => data.schoolId == this.schoolId)?.schoolUsers!;
  
          this.schoolAdminExists = this.schoolUsers.some(user =>
            user.role.some(role => role.roleId == Number(RoleMaster.SchoolAdmin))
          );

          let roles = this.roles.filter(x=>x.isActive);
          //if(!this.schoolAdminExists && !userDetail.schoolUserId)
          {
            if (!roles.some(r => r.roleId === Number(RoleMaster.SchoolAdmin)))
            {
              roles = [{
                roleId: Number(RoleMaster.SchoolAdmin),
                roleName: 'School Admin'
              } as Role, ...roles];
            }
          }

          this.dialog.open(AddSchoolUserComponent, {
            width: '1000px',
            data: {
              userDetail: userDetail.schoolUserId ? userDetail : {}, 
              assignedPackageId: this.packageId,
              roles: roles,
              schoolId: this.schoolId,
              clientAccountId: this.clientAccountId,
              allowBulkUpload: true,
              availableNumberOfSchoolUsersToCreate: numberOfUsers
            }
          }).afterClosed().subscribe((popupEvent: any)=>{
            if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
              if(popupEvent.data.isBulkUploaded){
                this.schoolService.getSchools(this.clientAccountId).subscribe((data: DtoSchool[] | any)=>{
                  this.schoolData = data;
                  this.schoolUsers = this.schoolData.find(data => data.schoolId == this.schoolId)?.schoolUsers!;
                }, (error: HttpErrorResponse)=>{
                  if(error.error){
                    this.toasterService.error(error.error, "Error");
                  }
                })
                return;
              }
              popupEvent.data.userDetails.schoolId = this.schoolId;
              this.schoolService.createSchoolUser([popupEvent.data.userDetails]).subscribe((response: any)=>{
                if(response.isSuccess){
                  this.toasterService.success("User details created successfully", "Success");
                  setTimeout(()=>{
                    this.schoolService.getSchools(this.clientAccountId).subscribe((data: DtoSchool[] | any)=>{
                      this.schoolData = data;
                      this.schoolUsers = this.schoolData.find(data => data.schoolId == this.schoolId)?.schoolUsers!;
                      if (popupEvent.data.fileData && popupEvent.data.fileData.has('file')) {
                        let schoolUsers = this.schoolData.find(data => data.schoolId == this.schoolId)?.schoolUsers;
                        const user = schoolUsers!.find(user => user.emailId === popupEvent.data.userDetails.emailId);
                        if(user){
                          this.uploadDocument(popupEvent.data.fileData, DocumentType.EntityAudience, user.userId.toString());
                        }
                      }
                    }, (error: HttpErrorResponse)=>{
                      if(error.error){
                        this.toasterService.error(error.error, "Error");
                      }
                    })
                  }, 1000);
                }
              },(err: HttpErrorResponse)=>{
                if(err.error){
                  this.toasterService.error(err.error, "Error");
                }
              })
            }
          });
        }, (error: HttpErrorResponse)=>{
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
        })
      }
    }
    catch (errorResponse: any) {
      this.toasterService.error(errorResponse.error, 'Error');
      return false;
    }
  }


  uploadDocument(formData: FormData, documentTypeId: string, referenceId: string) {
    this.matAccountService.uploadDocument(formData, documentTypeId, referenceId).subscribe(
      (res: any) => {
        if (res) {
          console.log("Uploaded Successfully");
        }
      },
      (error: HttpErrorResponse) => {
        if(error.error){
          this.toasterService.error(error.error, "Error");
        }
      }
    );
  }

  openDeleteSchoolUser(userIndex: number){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the school user?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.schoolUsers.splice(userIndex, 1)
      }
    });
  }
  
  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }
  
  ViewDocument(data: DtoSchool){
    if(!data.document.length){
      this.toasterService.warning("No attachment found");
      return;
    }
    this.dialog.open(ConfirmDialogComponent, {
      width: '675px',
      data: {
        hideUpload: true,
        files: data.document // Pass files to the dialog
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.doc){
        data.document = popupEvent.doc;
      }
    });
  }
}
